import {
	COMPANY_FIELDS_MAX_LENGTH,
	DESCRIPTION_MAX_LENGTH,
	TITLE_MAX_LENGTH,
} from 'constants/validationConstants'
import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

import { urlSchema } from '../fieldSchemas'

export const getDocumentInfoSchema = (t: TTranslationFunction) =>
	yup.object({
		company: yup.object({
			name: yup.string().max(
				COMPANY_FIELDS_MAX_LENGTH,
				t('ui__field_validation_errors__generic__max_length', {
					length: COMPANY_FIELDS_MAX_LENGTH,
				}),
			),
			title: yup.string().max(
				TITLE_MAX_LENGTH,
				t('ui__field_validation_errors__generic__max_length', {
					length: TITLE_MAX_LENGTH,
				}),
			),
			website: urlSchema(t, { required: false }),
			description: yup.string().max(
				DESCRIPTION_MAX_LENGTH,
				t('ui__field_validation_errors__generic__max_length', {
					length: DESCRIPTION_MAX_LENGTH,
				}),
			),
		}),
	})

export const getPdfFormSchema = (t: TTranslationFunction) =>
	yup.object({
		file: yup
			.object({
				key: yup.string().required(),
				bytes: yup.number().required(),
				format: yup.string().required(),
				publicId: yup.string().required(),
				resourceType: yup.string().required(),
				bucketRootUrl: yup.string().required(),
				storageProvider: yup.string().required(),
			})
			.nullable()
			.required(),
		company: getDocumentInfoSchema(t),
		isDirect: yup.boolean(),
	})

export type TPdfFormFields = InferType<ReturnType<typeof getPdfFormSchema>>
